export default [
  {
    path: "/purchase-orders/list",
    name: "purchase-orders-list",
    component: () =>
      import("@/views/inventory/purchase-order/orders-list/OrdersList.vue"),
    meta: {
      action: "read",
      resource: "purchase-orders",
    },
  },
  {
    path: "/purchase-orders/create",
    name: "purchase-orders-create",
    component: () =>
      import("@/views/inventory/purchase-order/orders-edit/OrdersEdit.vue"),
    meta: {
      action: "create",
      resource: "purchase-orders",
    },
  },
  //stocktakings
  {
    path: "/stocktakings",
    name: "stocktaking",
    component: () =>
      import("@/views/product/products-list/ProductStockTaking.vue"),
    meta: {
      action: "read",
      resource: "stocktakings",
    },
  },
  {
    path: "/stock-receive/list",
    name: "stock-receive",
    component: () =>
      import("@/views/inventory/stock-receipt/receipts-list/ReceiptsList.vue"),
    meta: {
      action: "read",
      resource: "stock-receives",
    },
  },
  {
    path: "/stock-receive/create",
    name: "stock-receive-create",
    component: () =>
      import("@/views/inventory/stock-receipt/receipts-edit/ReceiptsEdit.vue"),
    meta: {
      action: "create",
      resource: "stock-receives",
    },
  },
  {
    path: "/stock-issue/list",
    name: "stock-issue",
    component: () =>
      import("@/views/inventory/stock-issue/issues-list/IssuesList.vue"),
    meta: {
      action: "read",
      resource: "stock-issues",
    },
  },
  {
    path: "/stock-issue/create",
    name: "stock-issue-create",
    component: () =>
      import("@/views/inventory/stock-issue/issues-edit/IssuesEdit.vue"),
    meta: {
      action: "create",
      resource: "stock-issues",
    },
  },
];
